import { fetchAuthSession } from "aws-amplify/auth";
import config from "../config/environment";

// 12 chars: short enough that the token cannot be authenticated from; long enough
// to correlate log lines within a session across page loads.
const TOKEN_LOG_PREFIX_LENGTH = 12;

export const getUserSession = async () => {
  try {
    const session = await fetchAuthSession();

    const accessToken = session?.tokens?.accessToken?.toString();

    if (accessToken) {
      if (config.env === "development") {
        // Truncated prefix only; never log full token even in dev to keep
        // shoulder-surfing / log-aggregation risk at zero.
        console.log("[auth] Access token acquired:", accessToken.slice(0, TOKEN_LOG_PREFIX_LENGTH) + "…");
      }
      localStorage.setItem("userAccessToken", accessToken);
      return accessToken;
    }

    return null;
  } catch (error) {
    console.error("Error fetching auth session:", error);
    return null;
  }
};
